<template>
  <div class="hb-pay-list">
    <div v-for="item in hbInfos"
      :key="item.periods"
      :class="['hb-pay-item', {'hb-pay-item-checked': periods === item.periods}]"
      @click="handleSelectPeriods(item.periods)"
    >
      <div class="hb-pay-times">
        <span class="times-num">{{ item.periods }}</span>
        <span>期</span>
      </div>
      <div class="hb-pay-info">
        <div>分期价</div>
        <div>
          <span>￥</span>
          <span class="times-money">{{ item.prinAndFee }}</span>
          <span class="times-times">×</span><span> {{ item.periods }} </span>
        </div>
        <div class="times-fare">{{ item.allRateFee }}元/期</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getHbInfos } from '@/apis/pay'
export default {
  inject: {
    getOrderId: {
      value: 'getOrderId',
      default: null
    }
  },
  props: {
    // 销售渠道
    sellerCode: {
      type: String,
      default: ''
    },
    // 销售渠道Channel
    sellerChannel: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      hbInfos: [],
      checked: false,
      periods: null
    }
  },
  created () {
    const orderId = this.getOrderId?.()
    if (orderId) {
      this.getHbInfosByApi(orderId)
    }
  },
  methods: {
    async getHbInfosByApi (orderId) {
      const { sellerCode, sellerChannel } = this

      this.hbInfos = await getHbInfos({
        orderId,
        seller: sellerCode,
        sellerChannel
      })
    },
    handleSelectPeriods (periods) {
      this.periods = periods === this.periods ? null : periods
      this.$emit('selectPeriods', this.periods)
    }
  }
}
</script>
<style lang="less">
.hb-pay-list {
  display: flex;
  -webkit-box-pack: start;
  justify-content: flex-start;
  margin-top: 10px;
  .hb-pay-item {
    position: relative;
    width: 200px;
    height: 95px;
    background: #fff;
    display: inline-block;
    cursor: pointer;
    border: 1px solid #1678ff;
    border-radius: 5px;
    overflow: hidden;
    flex: 1 0 auto;
    display: flex;
    justify-content: space-between;
    & + .hb-pay-item {
      margin-left: 25px;
    }

    &-checked {
      background: #f5fbff;
      border: 0;
      box-shadow: 0 0 10px 0 rgba(143, 172, 196, 0.6);
    }
    &-checked:after {
      content: "";
      background: url("../images/hb-edge.png") no-repeat center;
      display: inline-block;
      background-size: contain;
      width: 25px;
      height: 25px;
      position: absolute;
      bottom: -1px;
      right: -1px;
      z-index: 10;
    }

    .hb-pay-info {
      margin-right: 25px;
      padding: 16px 0;
      color: #443b35;
      font-size: 14px;
      line-height: 1.6em;
      text-align: center;
      .times-num {
        color: #1678ff;
        font-size: 24px;
      }
      .times-money {
        color: #1678ff;
      }
      .times-times {
        margin: 0 2px;
      }
      .times-fare {
        color: #8a8a8a;
        font-size: 12px;
      }
    }
    .hb-pay-times {
      display: inline-block;
      box-sizing: border-box;
      text-align: center;
      color: #443b35;
      width: 53px;
      height: 53px;
      line-height: 53px;
      border-radius: 25px;
      border: 3px solid #f3f7fa;
      background: #fff;
      margin: 20px 0 0 10px;
      span {
        line-height: 1em;
      }
    }

  }

}
</style>
